import { render, staticRenderFns } from "./Notaenfermeria.vue?vue&type=template&id=73ade026&scoped=true"
import script from "./Notaenfermeria.vue?vue&type=script&lang=js"
export * from "./Notaenfermeria.vue?vue&type=script&lang=js"
import style0 from "./Notaenfermeria.vue?vue&type=style&index=0&id=73ade026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ade026",
  null
  
)

export default component.exports